module.exports = __webpack_public_path__ + "static/media/liefmans-yelloh.f1148bd0.jpg";